import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Content, SubContent, Main } from "../../../components/Layout";
import { Row, Col } from "react-bootstrap";
import useWrapper from "../../../hooks/useWrapper";
import { useOutletContext } from "react-router-dom";
import AttendanceTable from "../../../components/AttendanceTable";

export default function GroupAttendance() {
  const { commercial } = useOutletContext();
  const { setbreadcrumb } = useWrapper();
  const { commercialId } = useParams();

  const [attendances, setattendances] = useState();

  useEffect(() => {
    if (commercial?.institution?.name) {
      setbreadcrumb([{ label: "Turmas", url: "/groups" }, { label: commercial.institution.name }]);
    }
  }, [commercial]);

  return (
    <>
      <Main>
        <Content noBG="true">
          <Row>
            <Col>
              <SubContent>
                <Row className="mb-2">
                  <Col>
                    <h2 className="form-title">Atendimentos</h2>
                    <p className="small-label mb-2">
                      Acompanhe e gerencie os atendimentos registrados. Visualize o status de cada solicitação e
                      assegure um acompanhamento eficiente das interações com os formandos.
                    </p>
                  </Col>
                </Row>
                <AttendanceTable
                  query={`commercial_id=${commercialId}&paginate=false`}
                  applyFilter={() => {}}
                  attendances={attendances}
                  setattendances={setattendances}
                  url_type="group"
                  commercial_id={commercialId}
                />
              </SubContent>
            </Col>
          </Row>
        </Content>
      </Main>
    </>
  );
}
